import { render, staticRenderFns } from "./MaxLengthText.vue?vue&type=template&id=dd4f45fc&scoped=true"
import script from "./MaxLengthText.vue?vue&type=script&lang=js"
export * from "./MaxLengthText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4f45fc",
  null
  
)

export default component.exports